<template>
  <div class="h-full">
    <div  class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4">
      <div style="height: 100px;" class="relative shadow cursor-pointer rounded p-4 bg-white mt-10" @click="$router.push({name: 'EmailTemplateList', params: { entityId: 2, slug: 'job'}})">
        <p class="text-right text-text1 heading-3">
          Email Template
        </p>
        <div class="card_icon bg-blue-200 flex justify-center items-center">
          <span><img src="@/assets/images/svg/emailSvg.svg" class=" h-10" alt="img"></span>
        </div>
      </div>
      <div style="height: 100px;" class="relative shadow cursor-pointer rounded p-4 bg-white mt-10" @click="$router.push({name: 'AppSetting'})">
        <p class="text-right text-text1 heading-3">
          App Setting
        </p>
        <div class="card_icon bg-blue-200 flex justify-center items-center">
          <span><img src="@/assets/images/svg/mobileSvg.svg" class=" h-10" alt="img"></span>
        </div>
      </div>
      <div style="height: 100px;" class="relative shadow cursor-pointer rounded p-4 bg-white mt-10" @click="$router.push({name: 'Plans'})">
        <p class="text-right text-text1 heading-3">
          Plan Management
        </p>
        <div class="card_icon bg-blue-200 flex justify-center items-center">
          <span><img src="@/assets/images/svg/subscription.svg" class=" h-14" alt="img"></span>
        </div>
      </div>
      <div style="height: 100px;" class="relative shadow cursor-pointer rounded p-4 bg-white mt-10" @click="$router.push({name: 'EmailConfiguration'})">
        <p class="text-right text-text1 heading-3">
          Email Configuration
        </p>
        <div class="card_icon bg-blue-200 flex justify-center items-center">
          <span><img src="@/assets/images/svg/emailConf.svg" class=" h-12" alt="img"></span>
        </div>
      </div>
      <div style="height: 100px;" class="relative shadow cursor-pointer rounded p-4 bg-white mt-10" @click="$router.push({name: 'PasswordManager'})">
        <p class="text-right text-text1 heading-3">
          Password Management
        </p>
        <div class="card_icon bg-blue-200 flex justify-center items-center">
          <span><img src="@/assets/images/svg/passMan.svg" class=" h-14" alt="img"></span>
        </div>
      </div>
      <div style="height: 100px;" class="relative shadow cursor-pointer rounded p-4 bg-white mt-10" @click="$router.push({name: 'UserDetail'})">
        <p class="text-right text-text1 heading-3">
          User Profile
        </p>
        <div class="card_icon bg-blue-200 flex justify-center items-center">
          <span><img src="@/assets/images/svg/profile.svg" class=" h-14" alt="img"></span>
        </div>
      </div>
      <div style="height: 100px;" class="relative shadow cursor-pointer rounded p-4 bg-white mt-10" @click="updateOtp()">
        <p class="text-right text-text1 heading-3">
          Master OTP
        </p>
        <div class="card_icon bg-blue-200 flex justify-center items-center">
          <span><img src="@/assets/images/svg/masterOtp.svg" class=" h-14" alt="img"></span>
        </div>
      </div>

      <div style="height: 100px;" class="relative shadow cursor-pointer rounded p-4 bg-white mt-10" @click="$router.push({name: 'ImageCompSetting'})">
        <p class="text-right text-text1 heading-3">
          Image Compression Quality
        </p>
        <div class="card_icon bg-blue-200 flex justify-center items-center">
          <span><img src="@/assets/images/img-setting.png" class=" h-14" alt="img"></span>
        </div>
      </div>


      <div style="height: 100px;" class="relative shadow cursor-pointer rounded p-4 bg-white mt-10" @click="$router.push({name: 'BypassTestPhone'})">
        <p class="text-right text-text1 heading-3">
          Bypass Testing Phone Number
        </p>
        <div class="card_icon bg-blue-200 flex justify-center items-center">
          <span><img src="@/assets/images/shield.png" class=" h-14" alt="img"></span>
        </div>
      </div>

    </div>

    <div v-if="editDialog" class="popup_overlay px-4">
      <div class="custom_dialog rounded-lg pb-4" style="width: 600px;max-height: 95%;">
        <div class="relative bg-white">
          <div>
            <div class="bg-primary flex justify-between items-center p-3">
              <div class=" font-medium text-white heading-3">
                Update Master OTP
              </div>
              <div>
                <span class=" text-text1 heading-6 font-semibold cursor-pointer bg-gray1 px-3 py-2 rounded-lg uppercase" @click="editDialog = false;resetError()">
                  Cancel
                </span>
                <span class=" text-white heading-6 ml-2 font-semibold cursor-pointer bg-success px-3 py-2 rounded-lg uppercase" @click="saveUpdate(2)">
                  Update
                </span>
              </div>
            </div>
            <div class="p-2">
              <div class="">
                <div class="box col-span-6  p-2">
                  <p class="label_css">Master Otp</p>
                  <input
                  :class="reqObj.otpErr !== '' ? 'border border-error' :'border border-gray-500 focus:border-primary'"
                    class="outline-none text-gray-900 text-sm rounded block w-full pl-2 p-2.5 h-12 heading-4"
                    placeholder="Enter OTP"
                    @input="filterNumbers"
                    v-model="reqObj.otp"
                    @keypress="reqObj.otpErr=''"
                    :disabled="isLoading"
                  >
                  <p class="text-error" v-if="reqObj.otpErr !== ''">{{reqObj.otpErr}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
  </div>
</template>
<script>
import ADMINAPI from '@/View/Admin/api/Admin.js'
export default {
  data () {
    return {
      userDetail: {},
      settingOptions: [],
      cardHeight: window.innerHeight - 94,
      editDialog: false,
      reqObj: {
        otp: '',
        otpErr: ''
      }
    }
  },
  mounted () {
    document.title = 'Setting Dashboard'
    let userData = localStorage.getItem('employeeData')
    this.userDetail = JSON.parse(userData)
  },
  methods: {
    updateOtp () {
      this.editDialog = true
      this.reqObj.otp = ''
      this.reqObj.otpErr = ''
      this.getMasterOTP()
    },
    getMasterOTP () {
      this.$store.dispatch('SetLoader', {status: true, message: 'Loading...'})
      ADMINAPI.GetMasterOTP(
        response => {
          console.log('res')
          this.reqObj.otp = response.Data
          this.$store.dispatch('SetLoader', {status: false, message: ''})
        },
        error => {
          this.$store.dispatch('SetLoader', { status: false, message: '' })
          this.$store.dispatch('SetAlert', { showAlert: true, message: error.message, color: 'error' })
          this.editDialog = false // Close dialog on error if needed
        }
      )
    },
    // Helper to allow only numbers in input
    filterNumbers () {
      this.reqObj.otp = this.reqObj.otp.replace(/[^0-9]/g, '')
      this.reqObj.otpErr = ''
    },
    resetError () {
      this.reqObj.otpErr = ''
    },
    saveUpdate () {
      const otp = this.reqObj.otp

      if (!otp) {
        this.reqObj.otpErr = 'OTP is required'
        return
      }

      // 2. Check if exactly 6 digits
      if (!/^\d{6}$/.test(otp)) {
        this.reqObj.otpErr = 'OTP must be exactly 6 digits'
        return
      }
      this.isLoading = true
      this.reqObj.otpErr = ''
      this.$store.dispatch('SetLoader', { status: true, message: 'Updating...' })
      ADMINAPI.ChangeMasterOTP(
        otp,
        response => {
          this.$store.dispatch('SetLoader', { status: false, message: '' })
          this.$store.dispatch('SetAlert', { showAlert: true, message: 'Master OTP updated successfully', color: 'success' })
          this.editDialog = false // Close dialog on success
          this.isLoading = false
          console.log(response)
        },
        error => {
          this.$store.dispatch('SetLoader', { status: false, message: '' })
          this.$store.dispatch('SetAlert', { showAlert: true, message: error.message, color: 'error' })
          this.reqObj.otpErr = 'Failed to update OTP'
          this.isLoading = false
        }
      )
    }
  }
}
</script>

<style scoped>
.card-content {
  background-color: transparent;
  padding: 0rem;
  padding-top: 1rem;
  padding-right: 1rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
}
.sheets {
  border-radius: 10%;
  width: 70px !important;
  height: 67px !important;
  justify-content: center;
  display: flex;
  margin-top: -40px;
  border-color: #26c6da;
}
.hoverableCard:hover {
  box-shadow: 1px 5px 5px 1px rgba(38, 38, 38, 0.2);
  top: 0px;
  border: 0px solid #cccccc;
  /* background-color: rgb(244, 244, 244); */
  /* box-shadow: 0px 5px 5px 0px rgba(0,0,0,0.2); */
  /* transition:all 0.5s; */
  /* border: 0px solid #cccccc; */
}
.cardAbsolute {
  position: absolute;
  left: 20px;
  top: -30px;
  border-radius: 8%;
  width: 80px !important;
  height: 80px !important;
  text-align: center;
  justify-content: center;
  display: flex;
}
.marginTop {
  margin-top: 30px;
}

.card_icon{
    position: absolute;
    left: 20px;
    top: -30px;
    border-radius: 8%;
    width: 100px!important;
    height: 100px!important;
    text-align: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}
</style>
